<template>
  <div
    :style="{...fullPaddingSubject(section.options.customize.style), ...fullMarginSubject(section.options.customize.style), ...borderSubject(section.options.content.star, [0,0,0,0]), ...radiusSubject(section.options.content.star, [0,0,0,0]), ...backgroundColor}"
  >
    <slot />
  </div>
</template>

<script>
import TemplateMixin from '@builder/components/mixins/TemplateMixin'
import BorderMixin from '@/components/mixins/BorderMixin'

export default {
  name: 'AboutUs1Template',
  mixins: [TemplateMixin, BorderMixin]
}
</script>
